import styled, { css } from 'styled-components';

import { TextProps } from '.';
import { getFontStyle } from './helper';

export const TypoComponent = styled.span<TextProps>`
  ${({ typography }) => getFontStyle(typography)}
  ${({ color }) =>
    color &&
    css`
      color: ${({ theme }) => theme.colors[color]};
    `}
`;
